
export default function ThemeSwitcher(nightMode = true) {
    var MainColor = "";
    var SecondaryColor = "";
    // opposite of Main
    var TintThemeColor = "";

    var MainColorShadow = "";
    var SecondaryColorShadow = "";
    var TintThemeColorShadow = "";

    // number 6
    var DarkerMain = "";
    // number 7
    var LighterMain = "";

    // number 8
    var OptimeColor = "#00d4ff";
    // number 9
    var ErrorColor = "#f92323";
    // number 10
    var SuccessColor = "#1ec859";
    // number 11
    var WarnColor = "#f98006";
    // number 12
    var YellowColor = "#f9f91f";
    // number 13
    var BlueColor = "#80ccff";
    // number 14
    var PinkColor = "#F08080";
    // number 15
    var PurpleColor = "#800080";
    // number 16
    var DarkBlurColor = "#2c4b99";
    // number 17
    var WhiteTable = "#F5F8FF";

    if (nightMode) {
        MainColor = "#283B52";
        SecondaryColor = "rgb(50,69,92)";
        TintThemeColor = "#f3f2f2";

        MainColorShadow = "rgba(40,59,82,.3)";
        SecondaryColorShadow = "rgba(38,38,38, 0.3)";
        TintThemeColorShadow = "rgba(255, 255, 255,0.3)";

        DarkerMain = '#213145';
        LighterMain = '#3a5678';
    } else {
        MainColor = "#fdfdfd";
        SecondaryColor = "#f3f2f2";
        TintThemeColor = "#000000";

        MainColorShadow = "rgba(254,254,254,0.3)";
        SecondaryColorShadow = "rgba(254,254,254, 0.3)";
        TintThemeColorShadow = "rgba(0, 0, 0, 0.3)";

        DarkerMain = '#f1f1f1';
        LighterMain = '#fff';
    };

    return [
        MainColor,
        SecondaryColor,
        TintThemeColor,
        MainColorShadow,
        SecondaryColorShadow,
        TintThemeColorShadow,

        DarkerMain,
        LighterMain,

        OptimeColor,
        ErrorColor,
        SuccessColor,
        WarnColor,
        YellowColor,
        BlueColor,
        PinkColor,
        PurpleColor,
        DarkBlurColor,
        WhiteTable
    ];
}